// Masks the attributes Amplitude autocapture could read the value from. Amplitude can't mask `id` or `class`, so the value must never go in either.
export const SENSITIVE_ANALYTICS_ATTRIBUTES = {
  'data-amp-mask': true,
  'data-amp-mask-attributes': 'aria-label',
}

// Blocks the element from Amplitude session replay. Pair it with SENSITIVE_ANALYTICS_ATTRIBUTES.
export const SESSION_REPLAY_BLOCK_CLASS = 'amp-block'

export const truncate = (value: string, truncateMiddle: boolean | number) => {
  if (!truncateMiddle) return value
  const chars = typeof truncateMiddle === 'number' ? truncateMiddle : 10
  const hasHexPrefix = value.startsWith('0x')
  const body = hasHexPrefix ? value.slice(2) : value
  if (body.length <= chars * 2 + 3) return value
  const prefix = hasHexPrefix ? '0x' : ''
  return `${prefix}${body.slice(0, chars)}...${body.slice(-chars)}`
}
